import {$, w} from './constants';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    //Menú home
    if($('#header-home').length){
        $(window).scroll(function (event) {
            const cover = $("#slider-home");
            const logos = $('.header__logos')
            const menu = $(".header__hamburguer");

            logos.toggleClass('hide-in-scroll', $(this).scrollTop() > 5);
    
            if($(this).scrollTop() > cover.height() - 80){
                menu.addClass('active');
            }else{
                menu.removeClass('active');
            }
    
            
        });

    }
    $('.header__hamburguer').click(function(){
        $('.header__aside').toggleClass('show');
    })
    $('.header__close').click(function(){
        $('.header__aside').toggleClass('show');
    })

    //Slider home

    if($('#slider-home').length){
        $('#slider-home').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="landing-arrow landing-arrow--prev">',
            nextArrow: '<div class="landing-arrow landing-arrow--next">',
            dots: true,
            dotsClass: 'landing-dots',
            pauseOnHover: true,
            speed: 1000,
            autoplaySpeed: 6000,
            autoplay: true
        })
    }

    //Back to top
    $('#back-anchor').click(function(){
        $('html, body').animate(
            {
              scrollTop: $('#top-anchor').offset().top,
            },
            1200,
            'swing'
        )
    })
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

})
